//will send http request to backend to submit json note 

import axios from "axios"



export const sendCustomMsg = async (token, receiverPhone, message) => {
    const messageData = {
        receiverPhone,
        message
    };
    try {
        const response = await axios.post(`/api/dash/customMsg`, messageData, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        // Handle the response here
        if(response.status === 200){
            console.log(response.data)
            return response.data;
        }
        
    } catch (error) {
        // Handle the error here
        console.error(error);
        throw error;
    }
}
